export default __webpack_public_path__ + "static/media/stolen_credentials.dc725007.svg";